import { render, staticRenderFns } from "./ZoneEvent.vue?vue&type=template&id=5a2e2ed0&scoped=true"
import script from "./ZoneEvent.vue?vue&type=script&lang=js"
export * from "./ZoneEvent.vue?vue&type=script&lang=js"
import style0 from "./ZoneEvent.vue?vue&type=style&index=0&id=5a2e2ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e2ed0",
  null
  
)

export default component.exports